module.exports = "/assets/data/7ed74270273c9666abd537d6b899cbed-KT6.data.json";